var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-item-list"},[_c('list',{attrs:{"fs":_vm.itemFields,"api":"products","apiList":"products/myVariants?type=Product","addLink":_vm.addLink,"editLink":"/admin/products","showAction":_vm.showAction,"title":"Products Items"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }